import axios from 'axios';
import store from '../store';
import { LOGOUT } from '../actions/types';
import api from "./api";
import {BASE_URL_GIRE} from "./web-config";

const gireAPI = axios.create({
    baseURL: BASE_URL_GIRE,
    headers: {
        'Content-Type': 'application/json'
    }
});

export default gireAPI;




